import { registerLocaleData } from "@angular/common";
import localeArabic from "@angular/common/locales/ar";
import localeEN from "@angular/common/locales/en";
import localeES from "@angular/common/locales/es";
import localePT from "@angular/common/locales/pt";
import { inject, Injectable } from "@angular/core";
import { Auditor } from "@app/Domain/Models/auditor.model";
import { SessionStorageService } from "./session-storage.service";

import esMessages from "@assets/translate/dx-es.json";
import ptMessages from "@assets/translate/dx-pt.json";

import ESLocalization from "@assets/translate/dx-rich.es.json";
import PTLocalization from "@assets/translate/dx-rich.pt-BR.json";
import { loadMessages, locale } from "devextreme/localization";

@Injectable({ providedIn: "root" })
export class LocaleService {
    private _locale: string;

    private sessionStorage = inject(SessionStorageService);
    private auditor: Auditor = this.sessionStorage.get("auditor");

    set locale(value: string) {
        this._locale = value;
    }
    get locale(): string {
        if (this.auditor) this._locale = this.auditor.cultura;
        return this._locale || "pt-BR";
    }

    registerCulture(culture: string) {
        if (!culture) {
            return;
        }
        this.locale = culture;

        switch (culture) {
            case "pt-BR": {
                registerLocaleData(localePT);
                const combinedMessages = {
                    ...PTLocalization,
                    ...ptMessages
                };
                loadMessages({ pt: combinedMessages });
                break;
            }
            case "en-US": {
                registerLocaleData(localeEN);
                break;
            }
            case "es-ES": {
                const combinedMessages = {
                    ...ESLocalization,
                    ...esMessages
                };
                loadMessages({ es: combinedMessages });
                registerLocaleData(localeES);
                break;
            }
            case "ar": {
                registerLocaleData(localeArabic);
                break;
            }
        }

        locale(culture);
    }
}
